const {
  getElement,
  getElements,
  trapFocus,
  disableTrapFocus,
} = window.BAO.Utils

export class SiteDrawers extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (this.hasAlreadyBeenUsed) {
      throw new Error(
        `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
      )
    }

    this._activeDrawerKey = ''
    this.drawers = []

    this.triggerButton = ''

    window.drawers = this

    this.drawerKeys
      .filter(key => !this.triggerKeys.includes(key))
      .forEach(key =>
        console.info(`Drawer exists for ${key} but there is no trigger`),
      )

    this.isTouch = false
    this.mouseDown = false

    this.touchstartY = 0
    this.touchendY = 0
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )

    this.detectTouch = this.detectTouch.bind(this)

    this.onTouchStart = this.onTouchStart.bind(this)
    this.onTouchMove = this.onTouchMove.bind(this)
    this.onTouchEnd = this.onTouchEnd.bind(this)
    this.reInit = this.reInit.bind(this)

    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)

    if (this.els?.handle?.exists) {
      this.els.handle.elements.forEach(handle => {
        this.listeners.add(handle, 'touchstart', this.onTouchStart)
        this.listeners.add(handle, 'touchmove', this.onTouchMove)
        this.listeners.add(handle, 'touchend', this.onTouchEnd)

        this.listeners.add(handle, 'mousedown', this.onMouseDown)
        this.listeners.add(document, 'mousemove', this.onMouseMove)
        this.listeners.add(document, 'mouseup', this.onMouseUp)
      })
    }

    this.listeners.add(
      document.documentElement,
      'keydown',
      this.handleKeydown.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.COLLECTION.DRAWER_BUTTON_CHANGED,
      this.reInit,
    )
  }

  reInit () {
    this.setupListeners()
  }

  detectTouch () {
    this.isTouch = true
  }

  onTouchStart (event) {
    this.touchstartY = event.changedTouches[0].screenY

    this.setAttribute('drag', '')
  }

  onTouchMove (event) {
    const diffY = event.changedTouches[0].screenY - this.touchstartY

    if (diffY <= 0) return

    this.style.setProperty('--Drag', `${diffY}px`)
  }

  onTouchEnd (event) {
    this.touchendY = event.changedTouches[0].screenY

    this.style.setProperty('--Drag', `0px`)

    this.removeAttribute('drag')

    if (this.touchendY > this.touchstartY) {
      this.querySelector(`[data-drawers-close]`).click()
    }
  }

  onMouseDown (event) {
    if (this.isTouch === true) return

    this.mouseDown = true

    this.touchstartY = event.screenY

    this.setAttribute('drag', '')
  }

  onMouseMove (event) {
    if (this.isTouch === true) return

    if (this.mouseDown === false) return

    const diffY = event.screenY - this.touchstartY

    if (diffY <= 0) return

    this.style.setProperty('--Drag', `${diffY}px`)
  }

  onMouseUp (event) {
    if (this.isTouch === true) return

    if (this.mouseDown === false) return

    this.mouseDown = false

    this.touchendY = event.screenY

    this.style.setProperty('--Drag', `0px`)

    this.removeAttribute('drag')

    if (this.touchendY > this.touchstartY) {
      this.querySelector(`[data-drawers-close]`).click()
    }
  }

  handleClick (e) {
    const EVENTS = {
      TRIGGER: 'TRIGGER',
      CLOSE: 'CLOSE',
      BACKDROP: 'BACKDROP',
      EXTERNAL_BACKDROP: 'EXTERNAL_BACKDROP',
      UNKNOWN: 'UNKNOWN',
    }
    const eventType = (() => {
      if (e.target.closest(this.config.matches.trigger) !== null) {
        return EVENTS.TRIGGER
      } else if (e.target.closest(this.config.matches.close) !== null) {
        return EVENTS.CLOSE
      } else if (e.target.closest(this.config.matches.backdrop) !== null) {
        return EVENTS.BACKDROP
      } else if (
        e.target.closest(this.config.matches.externalBackdrop) !== null
      ) {
        return EVENTS.EXTERNAL_BACKDROP
      }

      return EVENTS.UNKNOWN
    })()

    if (eventType === EVENTS.UNKNOWN) return
    e.preventDefault()

    if (eventType === EVENTS.TRIGGER) {
      this.triggerButton = e.target.closest(this.config.matches.trigger)
      const key = this.triggerButton.getAttribute('data-drawers-trigger')
      const isBis = e.target.hasAttribute('data-bis')
      const extraDetail = {}

      if (isBis) {
        extraDetail.variantId = e.target.dataset.variantId
        extraDetail.variantTitle = e.target.dataset.variantTitle
      }

      const drawerOpen = new CustomEvent('drawerOpen', {
        detail: {
          key,
          ...extraDetail,
        },
      })

      // Aria expanded is set to true when the drawer is open.
      const currentState =
        this.triggerButton.getAttribute('aria-expanded') === 'true'
      this.triggerButton.setAttribute('aria-expanded', !currentState)

      document.dispatchEvent(drawerOpen)
      this.activeDrawerKey = key === this.activeDrawerKey ? '' : key

      const element = document.querySelector(`site-drawer[key='${key}']`)
      trapFocus(element)

      // Don't focus close button for search drawer, as we give focus to the search bar in search-drawer.js
      if (this.activeDrawerKey === 'search') return

      // If the PDP size-guide drawer is opened from the quick-buy, we ensure the quick-buy
      // modal is reopened when the size-guide drawer is closed.
      if (this.activeDrawerKey === 'size-guide') {
        const closeButtons = document.querySelectorAll(
          '[data-drawers-close="size-guide"]',
        )
        closeButtons.forEach(button => {
          if (
            this.triggerButton.hasAttribute('data-size-guide-mobile-trigger')
          ) {
            button.setAttribute('data-quick-buy-external-el', 'trigger')
            button.setAttribute('data-quick-buy-reopen', '')
          } else {
            button.removeAttribute('data-quick-buy-external-el')
            button.removeAttribute('data-quick-buy-reopen')
          }
        })
      }

      if (this.activeDrawerKey === 'shipping-selector') {
        window.setTimeout(
          () =>
            document
              .querySelector(`[data-shipping-selector-el="button"]`)
              .focus(),
          300,
        )

        return
      }
      if (
        document.querySelector(`[data-drawers-close="${this.activeDrawerKey}"]`)
      ) {
        window.setTimeout(
          () =>
            document
              .querySelector(`[data-drawers-close="${this.activeDrawerKey}"]`)
              .focus(),
          300,
        )
      }
    }

    if (
      eventType === EVENTS.CLOSE ||
      eventType === EVENTS.BACKDROP ||
      eventType === EVENTS.EXTERNAL_BACKDROP
    ) {
      let key = this.activeDrawerKey

      this.activeDrawerKey = ''

      if (this.triggerButton) {
        this.triggerButton.focus()

        this.triggerButton.setAttribute('aria-expanded', 'false')

        key = this.triggerButton.getAttribute('data-drawers-trigger')
      }

      const drawerClosed = new CustomEvent('drawerClosed', {
        detail: {
          key,
        },
      })

      document.dispatchEvent(drawerClosed)

      disableTrapFocus()

      if (eventType === EVENTS.CLOSE) {
        const drawerElement = this.querySelector(`[key='${key}']`)
        if (
          drawerElement &&
          drawerElement.getAttribute('data-module-drawers-delete-on-close')
        ) {
          drawerElement.remove()
        }
      }
    }
  }

  handleKeydown (e) {
    let key = this.activeDrawerKey

    if (key === '') return

    if (e.key !== 'Escape') return

    this.activeDrawerKey = ''

    if (this.triggerButton) {
      this.triggerButton.focus()

      key = this.triggerButton.getAttribute('data-drawers-trigger')
    }

    const drawerClosed = new CustomEvent('drawerClosed', {
      detail: {
        key,
      },
    })

    document.dispatchEvent(drawerClosed)
  }

  get triggerKeys () {
    return getElements('[data-drawers-trigger]').map(el =>
      el.getAttribute('data-drawers-trigger'),
    )
  }

  get drawerKeys () {
    return getElements('[data-module-drawers-drawer]').map(el =>
      el.getAttribute('data-module-drawers-drawer'),
    )
  }

  get hasAlreadyBeenUsed () {
    const el = getElement(this.nodeName.toLowerCase())

    return el !== this
  }

  get aDrawerIsOpen () {
    return this.drawers.some(drawer => drawer.isOpen)
  }

  get activeDrawerKey () {
    return this._activeDrawerKey
  }

  set activeDrawerKey (key) {
    this._activeDrawerKey = key

    this.drawers.forEach(drawer => (drawer.isOpen = drawer.key === key))
    this.drawers.forEach(drawer =>
      key === '' ? (drawer.isClosed = true) : null,
    )

    this.config.elements.drawers.classList.toggle(
      this.config.classes.activeClass,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.siteOverflowed,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.drawersOpenUtility,
      this.aDrawerIsOpen,
    )

    document.body.className = document.body.className.replace(
      /\bdrw-Drawers-[^ ]*[ ]?\b/g,
      '',
    )

    if (key !== '') {
      this.els.drawer.element.classList.add('drw-Drawers_Drawer-active')
      document.body.classList.add(`drw-Drawers-${key}`)
    } else {
      this.els.drawer.element.classList.remove('drw-Drawers_Drawer-active')
    }
  }

  get config () {
    return {
      matches: {
        trigger: '[data-drawers-trigger]',
        subNav: '[data-drawers-sub-nav]',
        back: '[data-drawers-back]',
        close: '[data-drawers-close]',
        backdrop: '[data-site-drawers-el="backdrop"]',
        externalBackdrop: '[data-site-drawers-external-el="backdrop"]',
      },
      classes: {
        activeClass: 'drw-Drawers-active',
        activeDrawerClass: 'drw-Drawer-active',
        siteOverflowed: 'util-SiteOverflowed',
        drawersOpenUtility: 'util-DrawersOpen',
      },
      elements: {
        body: document.body || document.documentElement,
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawers: document.querySelector('site-drawers'),
      },
    }
  }
}

customElements.define('site-drawers', SiteDrawers)
